<ms-showcase-option-group
    *ngFor="let optionGroup of showcaseOptionGroups; trackBy: trackOptionGroup; let index = index"
    [model]="optionGroup"
    [event]="event"
    [tracking]="tracking"
    [viewType]="viewType" />
